export default [
  {
    title: 'CMS',
    section: 'store',
    order: 0,
    icon: 'view_quilt',
    items: [
      {
        title: 'Pages',
        component: 'pages',
        section: 'store'
      },
      {
        title: 'Components',
        component: 'components',
        section: 'store'
      },
      {
        title: 'Settings',
        component: 'templates',
        section: 'store'
      }
    ]
  }
]
